import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { visuallyHidden } from "@mui/utils";
import { useNavigate } from 'react-router-dom';
import '../../css/property-list.css';
import {
  Card, Checkbox,Chip, Dialog, DialogTitle, FormLabel, FormControlLabel, Paper, Button, Divider, ListItemText, 
  Radio, RadioGroup, Select, Typography, MenuItem, FormControl, IconButton, InputLabel, TextField, Grid, TableHead, TableBody, TableCell, TableContainer, TableSortLabel, TableRow, Table,
  Tooltip, CircularProgress, useMediaQuery,
  DialogContent
} from '@mui/material';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { AppHelper } from '../../AppHelper';
import LoadingButton from '@mui/lab/LoadingButton';
import PageQuestion from '.././question';
import { useEssayContext } from "../../contexts/context-essay";
import CheckIcon from '@mui/icons-material/Check';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCellQuestion = [
 
  { id: "grade", numeric: false, disablePadding: false, label: "GRADE", align: "" },
  { id: "uploadType", numeric: false, disablePadding: false, label: "OWNERSHIP", align: "" },
  { id: "title", numeric: false, disablePadding: false, label: "TITLE", align: "" },  
  { id: "topic", numeric: false, disablePadding: false, label: "CONTENT", align: "" },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {	  
    onRequestSort(event, property);
  };
	
  const headCells = headCellQuestion;

  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || headCell.numeric ? "center" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function TopicText({ text, onClickShowMoreLess }) {
  const [expanded, setExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const checkOverflow = () => {
      // if content taller than visible area -> overflow
      const isOverflowing = el.scrollHeight > el.clientHeight + 1;
      setCanExpand(isOverflowing);
    };

    // allow layout to settle first
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [text]);

  const handleToggle = (e) => {
    e.stopPropagation(); // don’t trigger card click
    setExpanded((prev) => !prev);
    onClickShowMoreLess && onClickShowMoreLess();
  };

  return (
    <Box>
      <Typography
        ref={textRef}
        sx={{
          display: expanded ? "block" : "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: expanded ? "unset" : 3, // show 3 lines when collapsed
          overflow: "hidden",
        }}
      >
        {text}
      </Typography>

      {canExpand && (
        <span
          onClick={handleToggle}
          className="showMoreLess"
          style={{ display: "block", marginTop: 2, cursor: "pointer" }}
        >
          {expanded ? "Show Less" : "Show More"}
        </span>
      )}
    </Box>
  );
}



export default function PopQuestion({
  onClose, open, onSubmit, grade
}) {
  const oUser = AppHelper.userCacheGet();
  const { essayList, isEssayListLoaded, loadEssayList, essaySelect, essaySelectAttempt, essayRemove } = useEssayContext();

  const [tblOrderQuestion, setTblOrderQuestion] = React.useState("asc");
  const [tblOrderByQuestion, setTblOrderByQuestion] = React.useState("title");
  const [questionList, setQuestionList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);  
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [authOK, setAuthOK] = React.useState(false);
  const [question, setQuestion] = useState('');
  const [filterText, setFilterText] = useState("");
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [popQuestionOpen, setPopQuestionOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSa, setIsSa] = useState(false);
  const gradeList = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S4E', 'S5'];
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [imagePreview, setImagePreview] = React.useState({ open: false, src: '', alt: '' });
  const [answeredQuestionList, setAnsweredQuestionList] = useState([]);

  useEffect(() => {
    if (!isEssayListLoaded) return;

    const answeredIds = essayList.filter(e => e.questionId != null).map(e => e.questionId);
    setAnsweredQuestionList(answeredIds);

  }, [isEssayListLoaded, essayList]);


  const openImagePreview = (b64, alt='') => {
    setImagePreview({ open: true, src: `data:image/png;base64,${b64}`, alt });
  };
  const closeImagePreview = () => setImagePreview({ open: false, src: '', alt: '' });

  const listSortAndfilterQuestion = () => {
    var _list = [...questionList];
    
    if (grade && selectedGrade.length === 0) { 
      _list = _list.filter((r) => r.grade === grade);
    }
    //if grade filter is not sekected, have a dropdown filter for the grade - (by default all)
    if (selectedGrade.length > 0) {
      _list = _list.filter((r) => selectedGrade.includes(r.grade));
    }

	var searchText = filterText.toLowerCase() || '';
	
    if (questionList && questionList.length > 0) {
       _list = _list.filter(
        (r) =>
          r.title.toLowerCase().includes(searchText) ||
          r.grade.toLowerCase().includes(searchText)
      );
    }

    const answeredSet = new Set(answeredQuestionList);
    _list = _list.map(q => ({
      ...q,
      isAnswered: answeredSet.has(q.questionId),
    }));
    setPage(0);

    return stableSort(_list, (a, b) => {
      if (a.isAnswered !== b.isAnswered) {
        return a.isAnswered ? 1 : -1;  // answered question go to bottom
      }
      return getComparator(tblOrderQuestion, tblOrderByQuestion)(a, b)});
  };
  
  const visibleQuestions = React.useMemo(
    () => listSortAndfilterQuestion(),
    [questionList, tblOrderQuestion, tblOrderByQuestion, filterText, grade, selectedGrade, answeredQuestionList]
  );

  const fetchFilteredQuestions = async (searchText) => {    
      setFilterText(searchText);        
  };
  
  const tblSortQuestion = (event, property) => {	
    const isAsc = tblOrderByQuestion === property && tblOrderQuestion === "asc";
	
    setTblOrderQuestion(isAsc ? "desc" : "asc");
    setTblOrderByQuestion(property);
  };


  const fetchQuestions = async () => {
    setIsLoading(true);

    var url = 'api/question/list';

    if (oUser && isSa == true) {
      url = 'api/question/list/all';
    }
    else{
      url = 'api/question/list';
    }

    var _res = await AppHelper.apiPost(url, { token: oUser.token, includeImage:1 });
    if (!_res || !_res.status) {
      setIsLoading(false);
      return;
    }

    const questionsWithImages = await Promise.all(
      _res.data.map(async (question) => {
        if (question.firstImage) {
          try {
            const imagePath = await fetchImagePath(question.firstImage);
            return { ...question, imagePath };
          } catch (error) {
            console.error('Error fetching image:', error);
            return question;
          }
        }
        return question;
      })
    );

    questionsWithImages.forEach(x => {
      x.words = x.topic.split(' ');
      x.isLongText = x.words.length > 10;
      x.isExpanded = false;
    });

    setQuestionList(questionsWithImages);
    setFilteredQuestions(questionsWithImages);
    setIsLoading(false);
  };

  const fetchIAM = async (oUser) => {
    var _res = await AppHelper.apiPost('api/account/iam', { token: oUser.token });
    if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
      return;
    }
    setIsSa(true);
  }

  const fetchImagePath = async (arg) => {
    var _res = await AppHelper.apiPost('api/question/image', { token: oUser.token, image: arg });
    if (!_res || !_res?.status || !_res.data) {
      return;
    }
    return _res.data;
  }

  const viewImage = async (arg) => {
    const imgPath = await fetchImagePath(arg);

    const byteCharacters = atob(imgPath);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });  // Create Blob from binary data
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');
  }

  const onAddQuestion = () => {
    setPopQuestionOpen(true);
  }

  const popQuestionClose = (shouldRefresh) => {
    setPopQuestionOpen(false);
    if (shouldRefresh) {
      fetchQuestions();
    }
  }


  useEffect(() => {
    var _user = AppHelper.userCacheGet();
    setAuthOK(_user != null);

    if (_user && open && questionList.length === 0) {
      fetchIAM(_user);
      fetchQuestions();
    }
  }, [open, questionList.length]);

  useEffect(() => {
    if (open && grade) {
      console.log("Grade", grade);
      setSelectedGrade([grade]);
    }
  }, [open, grade]);

  const handleGradeSelect = (event) => {
    const { value } = event.target;
    setSelectedGrade(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleSubmit = async (argQuestionId) => {
    var _q = questionList.find(r => r.questionId == argQuestionId);
    if (!_q) {
      _q = -1;
    }
    if (_q != -1) {
      const imagePath = await fetchImagePath(_q.firstImage);
      _q.imagePath = imagePath;
    }
	
    if (onSubmit) {
      onSubmit(_q);
      onClose(_q.questionId ? _q.questionId : -1);
    }
    else onClose(question == '' ? -1 : question);
  };

  const handleClose = () => { onClose() };
  const toggleExpanded = (arg) => {
    var _list = [...filteredQuestions];
    var _rec = _list.find(x => x.questionId == arg.questionId);
    if (!_rec) return;
    _rec.isExpanded = !_rec.isExpanded;
    setFilteredQuestions(_list);
  }
  
  const isMobile = useMediaQuery('(max-width:600px)'); // Detect small screens
  return (
    <>
      <Dialog onClose={handleClose} open={open} fullWidth
        maxWidth={false}
        sx={{ '& .MuiDialog-paper': { 
          width: '75%', maxWidth: 'none', 
          height: '80vh', maxHeight: '80vh', 
          display: 'flex', flexDirection: 'column' } }}
      >
        <DialogTitle sx={{ position: "sticky", top: 0, zIndex: 3, bgcolor: 'background.paper', fontWeight: 700 }}>
          {"SELECT QUESTION"}
        </DialogTitle>
        <DialogContent sx={{ flex: 1, overflowY: 'auto' }}>
          <Box alignItems="flex-start">
            <Box sx={{ position: "sticky", top: 0, zIndex: 3, bgcolor: 'background.paper', mb: 1, py: 1}}>
            {/* Container Grid: Filter bar and Grade Filter */}
            <Grid container xs={12}>
              {/* Grid: Filter */}
              <Grid item xs={8}>
                <Box mr={0.5}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Search questions"
                    onChange={(e) => fetchFilteredQuestions(e.target.value)}
                    value={filterText} 
                  />
                </Box>
              </Grid>
              {/* Grid: Grade filter */}
              <Grid item xs={4} sm={4} >
                <div>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel>Select Grade</InputLabel>
                    <Select
                      multiple
                      value={selectedGrade}
                      onChange={handleGradeSelect}
                      input={<OutlinedInput label="Select Grade" />}
                      renderValue={(selected) => {
                        const max = 3;
                        const visible = selected.slice(0, max);
                        const hiddenCount = selected.length - max;
                        return (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {visible.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                          {hiddenCount > 0 && (
                            <Chip label={`+${hiddenCount}`} size="small"/>
                          )}
                        </Box>
                        )
                      }}
                    >
                      {gradeList.map((grade) => (
                        <MenuItem key={grade} value={grade}>
                          <Checkbox checked={selectedGrade.includes(grade)} />
                          <ListItemText primary={grade} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
            </Grid>

            {true &&
              <Grid container >
                <Grid item xs={6} sx={{ mt: 1 }}>
                    <Button
                      onClick={() => onAddQuestion()}
                      // className="app-btn-bg"
                      variant="outlined"
                      size="large"
                      sx={{
                        width: '99%', 
                        height: '100%', 
                        mr: '2px',
                        color: 'rgba(19,130,117,1)',
                        borderColor: 'rgba(19,130,117,1)',
                        '&:hover': {
                          backgroundColor: 'rgba(19,130,117,0.08)',
                          borderColor: 'rgba(19,130,117,1)',
                        },
                      }}
                    >
                      ADD QUESTION
                    </Button>
                </Grid>
                <Grid item xs={6} sx={{mt: 1}}>
                    <Button
                      onClick={() => handleSubmit('')}
                      className="app-btn-bg"
                      color="info"
                      variant="contained"
                      size="large"
                      sx={{
                        width: '99%', 
                        height: '100%', 
                        ml: '3px',
                      }}
                    >
                      Submit without question
                    </Button>
                </Grid>
              </Grid>
            }
            </Box>

            <Grid container spacing={1}>
              {isLoading &&
                <Grid sx={{ mt: 0.5, ml: 1.5, width: "100%"}}>
                  <CircularProgress />
                </Grid>
              }
              {visibleQuestions && visibleQuestions.length > 0 &&
                visibleQuestions.map((item) => (
                  <Grid item 
                    key={item.questionId}
                    xs={ isMobile ? 12 : 6 } 
                    display="flex" >
                    <Card 
                      onClick={() => handleSubmit(item.questionId)}
                      sx={{ 
                        p: 1, 
                        pb: 0, 
                        width: '100%', 
                        minHeight: '10rem', 
                        cursor:'pointer',
                        border: "1px solid rgba(159, 170, 169, 1)", 
                        '&:hover':{ boxShadow: 3, },
                        boxShadow: 0, 
                        display: 'flex', 
                        flexDirection: 'column', 
                        position: 'relative', 
                        overflow: 'visible'
                    }}>
                      <Box sx={{ flexGrow: 1,  display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2 }}>
                        <Box sx={{ flex: 1 }}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Chip 
                              label={item.grade} 
                              sx={{
                                height:'25px', 
                                backgroundColor:'rgb(19, 130, 117)', 
                                color: 'rgb(255, 255, 255)', }}
                            /> 
                            <Typography variant="caption" sx={{ fontSize: '0.8rem', color: 'text.secondary', fontWeight: 700  }}>
                              {item.saQuestion === 1
                                ? ""
                                : item.uploadType === 0
                                ? "SELF"
                                : "TUITION CENTER"}
                            </Typography>
                          </Box>

                          <Box sx={{ ml: "0.5px", mt: 1 }}>
                            <Typography sx={{fontWeight: 700}}>
                              {item.title}
                            </Typography>
                          </Box>

                          {item.topic !== "-" && (
                            <TopicText text={item.topic} />
                          )}

                          </Box>
                          {item.images > 0 && item.imagePath && (
                            <Box sx={{ mt: 1, ml: "1px", alignItems: "right", justifyContent: "right" }}>
                              <Box
                                sx={{
                                  flexShrink: 0,
                                  width: 'auto',
                                  height: 120,
                                  maxWidth: 120, 
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  position: 'relative'
                                }}
                              >
                              <Tooltip title="Click to view full image" arrow>
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openImagePreview(item.imagePath, item.title);
                                  }}
                              sx={{
                                position: 'absolute',
                                top: "50%", 
                                left: "50%", 
                                transform: "translate(-50%, -50%)", 
                                color: 'rgba(255, 255, 255, 0.8)', 
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', 
                                '&:hover': {
                                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                  boxShadow: 3,
                                },
                              }}>
                                <OpenInFullIcon />
                            </IconButton>
                            </Tooltip>
                                <img
                                  src={`data:image/png;base64,${item.imagePath}`}
                                  alt={item.title}
                                  style={{
                                    width: 'auto',
                                    height: '100%',
                                    objectFit: 'contain', // ensures image is fully visible (not cropped)
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    border: '1px solid #a3a3a4ff', 
                                  }}

                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevent triggering the card click
                                    // Open image in same window as pop-up
                                    openImagePreview(item.imagePath, item.title);
                                    // Open image in new window
                                    // const byteCharacters = atob(item.imagePath);
                                    // const byteNumbers = new Array(byteCharacters.length);

                                    // for (let i = 0; i < byteCharacters.length; i++) {
                                    //   byteNumbers[i] = byteCharacters.charCodeAt(i);
                                    // }

                                    // const byteArray = new Uint8Array(byteNumbers);
                                    // const blob = new Blob([byteArray], { type: 'image/png' });
                                    // const blobUrl = URL.createObjectURL(blob);
                                    // window.open(blobUrl, '_blank');
                                  }}
                                />
                                </Box>
                            </Box>
                          )}
                      </Box>
                        {item.isAnswered && (
                          <Box
                            sx={{
                              mt: 1.5,
                              mx: -1, 
                              px: 2, 
                              py: 1, 
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              backgroundColor: '#F0FDF4', 
                              borderTop: '1px solid #DCFCE7', 
                              flexShrink: 0, 
                              borderBottomLeftRadius: '4px', 
                              borderBottomRightRadius: '4px',
                            }}
                          >
                            <CheckIcon
                              sx={{ fontSize: 18, color: '#16A34A' }}   // green-600
                            />
                            <Typography
                              sx={{
                                fontSize: '0.875rem', 
                                fontWeight: 500, 
                                color: '#15803D', 
                              }}
                            >
                              Attempted
                            </Typography>
                          </Box>
                        )}

                    </Card>
                  </Grid>
              ))}

            </Grid>
          </Box>
        </DialogContent>


        {/* <Box pl={2} pr={2} pb={2} alignItems="flex-start">
          <Grid container>
            <Grid item xs={12}>
              <Box style={{ textAlign: 'center' }}>
                <LoadingButton
				  className="app-btn-bg"
					sx={{
					color: "white", // Change text color to white
				  }}
                  onClick={() => handleSubmit('')} // Pass questionId to handleSubmit
                  loading={isSubmitting}
                  variant="outlined"
                >
                  <span>Submit without question</span>
                </LoadingButton>
              </Box>
                    <Grid item xs={6} sm={6}>
                      {true &&
                        <Button
                          onClick={() => onAddQuestion()}
                          className="app-btn-bg"
                          color="info"
                          variant="contained"
                          size="large"
                          style={{ marginRight: '2px', marginBottom: '8px' }} // Adjust the marginBottom value as needed	  
                        >
                          ADD QUESTION
                        </Button>
                      }
                    </Grid>

              <Box m={0.5}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Filter questions"
                  onChange={(e) => fetchFilteredQuestions(e.target.value)}
                  value={filterText}
                />
              </Box>
              <Box m={0.5}>
                <TableContainer style={{ maxHeight: 400, overflowY: 'auto' }}
                  component={Paper}
                  className="scrollbar-001"
                >
                  <Table stickyHeader>
                   
					<EnhancedTableHead
                      order={tblOrderQuestion}
                      orderBy={tblOrderByQuestion}
                      onRequestSort={tblSortQuestion}
                      rowCount={visibleQuestions.length}
                      gid="G1"
                    />
					
                    <TableBody>
                      {isLoading &&
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            <CircularProgress/>
                          </TableCell>
                        </TableRow>
                      }
                      {visibleQuestions && visibleQuestions.length > 0 &&
                        visibleQuestions.map((item) => (
                          <TableRow key={item.questionId}
                          onClick={() => handleSubmit(item.questionId)}
                          sx={{cursor:'pointer', 
                            '&:hover':{backgroundColor: 'rgba(0, 0, 0, 0.1)'}, 
                          }}>
                            <TableCell>
                            <Chip label={item.grade} 
                                  sx={{height:'25px', 
                                       backgroundColor:'rgb(19, 130, 117)', 
                                       color: 'rgb(255, 255, 255)', 
                                       marginTop: '1px', 
                                       paddingBottom:'-5px'}}
                            />
                            </TableCell>
                            <TableCell align="left">{item.saQuestion == 1 ? "SYSTEM" : item.uploadType == 0 ? "SELF" : "TUITION CENTER "}</TableCell>
                            <TableCell>{item.title}</TableCell>
                            <TableCell>
                              {item.topic !== "-" ? (
                                <Typography>
                                  {item.isLongText}
                                  {item.isExpanded || !item.isLongText ? item.topic : item.words.slice(0, 10).join(" ") + "..."}
                                  {item.isLongText && (
                                    <span onClick={() => toggleExpanded(item)} style={{ display: 'block', margin: 0 }} className="showMoreLess">
                                      {item.isExpanded ? " Show Less" : " Show More"}
                                    </span>
                                  )}
                                </Typography>
                              ) : (
                                <Button sx={{ textTransform: 'none', marginLeft: '-0.5rem' }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    viewImage(item.firstImage);
                                  }}> 
                                  Click to view image
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Box> */}
        
        <PageQuestion
          open={popQuestionOpen}
          onClose={popQuestionClose}
        />
      </Dialog>
      {/* This will open image as pop-up window.  */}
      <Dialog open={imagePreview.open} onClose={closeImagePreview} maxWidth="md" fullWidth>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', boxShadow: 1  }}>
          {/* using the already-built data URL */}
          <img
            src={imagePreview.src}
            alt={imagePreview.alt || 'Preview'}
            style={{ maxWidth: '100%', height: 'auto' }}
            onClick={(e) => e.stopPropagation()} // avoid bubbling
          />
        </Box>
      </Dialog>
    </>
  );
}
